import React, { useContext } from "react";
import { Formik } from "formik";
import { Input, InputNumber } from "formik-antd";
import MultiStepFormContext from "./MultiStepFormContext";
import './JobOnboarding.css';
import Button from "../../components/Button/Button";

const Details = () =>
{

  const { details, setDetails, next, prev } = useContext(MultiStepFormContext);

  return (
    <Formik
      initialValues={details}
      onSubmit={(values) =>
      {
        setDetails(values);
        console.log("setDetails:", values);
        next();
      }}
      validate={(values) =>
      {
        const errors = {};

        if (!values.title)
        {
          errors.title = "Title is required";
        }
        if (!values.postcode)
        {
          errors.postcode = "Postcode is required";
        }
        if (!values.description)
        {
          errors.description = "Job Description is required";
        }

        return errors;
      }}
    >
      {({ handleSubmit, handleChange, values, errors, touched }) =>
      {
        return (
          <div>

            <div className='form-main'>
              <div className='form-row'>
                {/* Job Title Field */}
                <div className="form-group">
                  <label>Job Title</label>
                  <div class="form-control-wrapper">
                    <Input
                      className="form-control"
                      placeholder="Enter Job Title"
                      name={"title"}
                      value={values.title}
                      onChange={handleChange}
                    />
                  </div>
                  {/* Show error only if field is touched */}
                  {touched.title && errors.title && (
                    <p className="error__feedback">{errors.title}</p>
                  )}
                </div>

                {/* Postcode Field */}
                <div className='form-group'>
                  <label>Postcode</label>
                  <div class="form-control-wrapper">
                    <input
                      className="form-control"
                      placeholder="Postcode"
                      name="postcode"
                      type="text"
                      value={values.postcode}
                      maxLength={4}
                      min={0}
                      onChange={(e) =>
                      {
                        const { value } = e.target;
                        // Check if the value is a number and update state only if it is
                        if (/^\d*$/.test(value))
                        { // Regular expression to allow only digits
                          handleChange({ target: { name: 'postcode', value } });
                        }
                      }}
                    />
                  </div>
                  {/* <InputNumber
                  className="rounded-pill input-box-shadow"
                  placeholder="Postcode"
                  name="postcode"
                  value={values.postcode}
                  onChange={(value) => handleChange({ target: { name: 'postcode', value } })}
                  maxLength={6}
                  min={0}
                  // style={{ width: 270, height: 40, display: 'flex', alignItems: 'center' }}
                /> */}
                  {/* Show error only if field is touched */}
                  {touched.postcode && errors.postcode && (
                    <p className="error__feedback">{errors.postcode}</p>
                  )}
                </div>

              </div>
            </div>

            <div className='form-main'>
              <div className='form-row'>
                <div className='form-group'>
                  <label>Job Description</label>
                  <div class="form-control-wrapper">
                    <Input.TextArea
                      name="description"
                      value={values.description}
                      onChange={handleChange}
                      placeholder="Enter Description"
                      className="form-control"
                      rows={4}
                    />
                  </div>
                  {/* Show error only if field is touched */}
                  {touched.description && errors.description && (
                    <p className="error__feedback">{errors.description}</p>
                  )}
                </div>
              </div>
            </div>

            <div className="onboarding-form-button">
              {/* <div></div>
              <p type={"primary"} onClick={handleSubmit} className="button_section_button">
                Next
              </p> */}
              <button type="button" onClick={prev}>Back</button>
              <button onClick={handleSubmit} type="button">Next</button>
            </div>


          </div>
        );
      }}
    </Formik>
  );
};
export default Details;
